import { defaultColors, keychaine, useColorModeValue as mode } from '@chaine/keychaine'
import * as React from 'react'

interface Props {
  height?: number
  width?: number
}

/**
 * The verification status of the user or workspace, will display the verification icon next to the name if true
 */
export const VerifiedIcon = React.memo((props: Props) => {
  const { width = 4, height = 4 } = props
  const bgColor1 = mode(defaultColors.blue[400], defaultColors.blue[600])
  const bgColor2 = mode(defaultColors.blue[500], defaultColors.blue[700])

  return (
    <keychaine.svg
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Verified Icon"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.3026 1.72851C7.71762 1.42383 8.28238 1.42383 8.6974 1.72851L9.62494 2.40945C9.9729 2.66489 10.3774 2.83246 10.8041 2.89787L11.9415 3.07225C12.4504 3.15027 12.8497 3.54962 12.9277 4.05852L13.1021 5.19589C13.1675 5.62256 13.3351 6.0271 13.5906 6.37506L14.2715 7.3026C14.5762 7.71762 14.5762 8.28238 14.2715 8.6974L13.5906 9.62494C13.3351 9.9729 13.1675 10.3774 13.1021 10.8041L12.9277 11.9415C12.8497 12.4504 12.4504 12.8497 11.9415 12.9277L10.8041 13.1021C10.3774 13.1675 9.9729 13.3351 9.62494 13.5906L8.6974 14.2715C8.28238 14.5762 7.71762 14.5762 7.3026 14.2715L6.37506 13.5906C6.0271 13.3351 5.62256 13.1675 5.19589 13.1021L4.05852 12.9277C3.54962 12.8497 3.15027 12.4504 3.07225 11.9415L2.89787 10.8041C2.83246 10.3774 2.66489 9.9729 2.40945 9.62494L1.72851 8.6974C1.42383 8.28238 1.42383 7.71762 1.72851 7.3026L2.40945 6.37505C2.66489 6.0271 2.83246 5.62256 2.89787 5.19589L3.07225 4.05852C3.15027 3.54962 3.54962 3.15027 4.05852 3.07225L5.19589 2.89787C5.62256 2.83246 6.0271 2.66489 6.37505 2.40945L7.3026 1.72851ZM11.2803 5.71967C11.5732 6.01256 11.5732 6.48744 11.2803 6.78033L7.53033 10.5303C7.23744 10.8232 6.76256 10.8232 6.46967 10.5303L4.71967 8.78033C4.42678 8.48744 4.42678 8.01256 4.71967 7.71967C5.01256 7.42678 5.48744 7.42678 5.78033 7.71967L7 8.93934L10.2197 5.71967C10.5126 5.42678 10.9874 5.42678 11.2803 5.71967Z"
          fill="url(#paint0_linear_7938_963)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.41493 0.51936C7.3582 -0.17312 8.64181 -0.17312 9.58507 0.51936L10.5126 1.2003C10.6657 1.31269 10.8437 1.38642 11.0314 1.4152L12.1688 1.58958C13.3254 1.76691 14.2331 2.67456 14.4104 3.8312L14.5848 4.96858C14.6136 5.1563 14.6873 5.33429 14.7997 5.48738L15.4806 6.41493C16.1731 7.3582 16.1731 8.6418 15.4806 9.58507L14.7997 10.5126C14.6873 10.6657 14.6136 10.8437 14.5848 11.0314L14.4104 12.1688C14.2331 13.3254 13.3254 14.2331 12.1688 14.4104L11.0314 14.5848C10.8437 14.6136 10.6657 14.6873 10.5126 14.7997L9.58507 15.4806C8.6418 16.1731 7.3582 16.1731 6.41493 15.4806L5.48738 14.7997C5.33429 14.6873 5.1563 14.6136 4.96858 14.5848L3.8312 14.4104C2.67456 14.2331 1.76691 13.3254 1.58958 12.1688L1.4152 11.0314C1.38642 10.8437 1.31269 10.6657 1.2003 10.5126L0.51936 9.58507C-0.17312 8.6418 -0.17312 7.3582 0.51936 6.41493L1.2003 5.48738C1.31269 5.33429 1.38642 5.1563 1.4152 4.96858L1.58958 3.8312C1.76691 2.67456 2.67456 1.76691 3.8312 1.58958L4.96858 1.4152C5.1563 1.38642 5.33429 1.31269 5.48738 1.2003L6.41493 0.51936ZM8.6974 1.72851C8.28238 1.42383 7.71762 1.42383 7.3026 1.72851L6.37505 2.40945C6.0271 2.66489 5.62256 2.83246 5.19589 2.89787L4.05852 3.07225C3.54962 3.15027 3.15027 3.54962 3.07225 4.05852L2.89787 5.19589C2.83246 5.62256 2.66489 6.0271 2.40945 6.37505L1.72851 7.3026C1.42383 7.71762 1.42383 8.28238 1.72851 8.6974L2.40945 9.62494C2.66489 9.9729 2.83246 10.3774 2.89787 10.8041L3.07225 11.9415C3.15027 12.4504 3.54962 12.8497 4.05852 12.9277L5.19589 13.1021C5.62256 13.1675 6.0271 13.3351 6.37506 13.5906L7.3026 14.2715C7.71762 14.5762 8.28238 14.5762 8.6974 14.2715L9.62494 13.5906C9.9729 13.3351 10.3774 13.1675 10.8041 13.1021L11.9415 12.9277C12.4504 12.8497 12.8497 12.4504 12.9277 11.9415L13.1021 10.8041C13.1675 10.3774 13.3351 9.9729 13.5906 9.62494L14.2715 8.6974C14.5762 8.28238 14.5762 7.71762 14.2715 7.3026L13.5906 6.37506C13.3351 6.0271 13.1675 5.62256 13.1021 5.19589L12.9277 4.05852C12.8497 3.54962 12.4504 3.15027 11.9415 3.07225L10.8041 2.89787C10.3774 2.83246 9.9729 2.66489 9.62494 2.40945L8.6974 1.72851Z"
          fill="url(#paint1_linear_7938_963)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_7938_963"
            x1="7.99999"
            y1="0"
            x2="7.99999"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={bgColor1} />
            <stop offset="1" stopColor={bgColor2} />
          </linearGradient>
          <linearGradient
            id="paint1_linear_7938_963"
            x1="7.99999"
            y1="0"
            x2="7.99999"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={bgColor1} />
            <stop offset="1" stopColor={bgColor2} />
          </linearGradient>
        </defs>
      </svg>
    </keychaine.svg>
  )
})

VerifiedIcon.displayName = 'VerifiedIcon'

/**
 * The verification status of the user or workspace, will display the verification icon next to the name if false
 */
export const UnverifiedIcon = React.memo((props: Props) => {
  const { width = 4, height = 4 } = props
  const bgColor1 = mode(defaultColors.orange[500], defaultColors.orange[600])
  const bgColor2 = mode(defaultColors.orange[600], defaultColors.orange[700])

  return (
    <keychaine.svg
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Unverified Icon"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.41493 0.51936C7.3582 -0.17312 8.64181 -0.17312 9.58507 0.51936L10.5126 1.2003C10.6657 1.31269 10.8437 1.38642 11.0314 1.4152L12.1688 1.58958C13.3254 1.76691 14.2331 2.67456 14.4104 3.8312L14.5848 4.96858C14.6136 5.1563 14.6873 5.33429 14.7997 5.48738L15.4806 6.41493C16.1731 7.3582 16.1731 8.6418 15.4806 9.58507L14.7997 10.5126C14.6873 10.6657 14.6136 10.8437 14.5848 11.0314L14.4104 12.1688C14.2331 13.3254 13.3254 14.2331 12.1688 14.4104L11.0314 14.5848C10.8437 14.6136 10.6657 14.6873 10.5126 14.7997L9.58507 15.4806C8.6418 16.1731 7.3582 16.1731 6.41493 15.4806L5.48738 14.7997C5.33429 14.6873 5.1563 14.6136 4.96858 14.5848L3.8312 14.4104C2.67456 14.2331 1.76691 13.3254 1.58958 12.1688L1.4152 11.0314C1.38642 10.8437 1.31269 10.6657 1.2003 10.5126L0.51936 9.58507C-0.17312 8.6418 -0.17312 7.3582 0.51936 6.41493L1.2003 5.48738C1.31269 5.33429 1.38642 5.1563 1.4152 4.96858L1.58958 3.8312C1.76691 2.67456 2.67456 1.76691 3.8312 1.58958L4.96858 1.4152C5.1563 1.38642 5.33429 1.31269 5.48738 1.2003L6.41493 0.51936ZM9 11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55229 10 9 10.4477 9 11ZM6.92086 6.08541C7.00138 5.92438 7.11037 5.78617 7.25982 5.68654C7.40457 5.59004 7.63128 5.5 8.00004 5.5C8.27979 5.5 8.55295 5.58656 8.73754 5.725C8.90211 5.84842 9.00004 6.01009 9.00004 6.25C9.00004 6.42662 8.95924 6.51381 8.92288 6.56835C8.87752 6.63639 8.79929 6.71162 8.6465 6.81349C8.57011 6.86441 8.48792 6.9139 8.38758 6.97411L8.38145 6.97779C8.28776 7.03401 8.17709 7.10041 8.06836 7.1729C7.84613 7.32107 7.58062 7.52712 7.37598 7.83412C7.14624 8.17878 7.2394 8.64442 7.58406 8.87417C7.92872 9.10391 8.39436 9.01075 8.62411 8.66609C8.66947 8.59803 8.74771 8.52279 8.90048 8.42093C8.97686 8.37001 9.05905 8.32052 9.15938 8.26032L9.16559 8.25659C9.25926 8.20039 9.36991 8.134 9.47858 8.06154C9.7008 7.91339 9.96631 7.70737 10.171 7.4004C10.3846 7.07994 10.5 6.69838 10.5 6.25C10.5 5.48991 10.1396 4.90158 9.63754 4.525C9.15547 4.16344 8.55363 4 8.00004 4C7.3688 4 6.84551 4.15996 6.42777 4.43846C6.01472 4.71383 5.74871 5.07562 5.57922 5.41459C5.39398 5.78507 5.54415 6.23558 5.91463 6.42082C6.28512 6.60606 6.73562 6.45589 6.92086 6.08541Z"
          fill="url(#paint0_linear_7938_2075)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_7938_2075"
            x1="7.99999"
            y1="0"
            x2="7.99999"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={bgColor1} />
            <stop offset="1" stopColor={bgColor2} />
          </linearGradient>
        </defs>
      </svg>
    </keychaine.svg>
  )
})

UnverifiedIcon.displayName = 'UnverifiedIcon'
